import { Button, CardContent, Flex, Image, SummaryItem, Text } from '@pega/cosmos-react-core';
import date from 'date-and-time';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Logos from '../../constants/images';
import useLocalTranslation from '../../hooks/useLocalTranslation';
import { ConfigurationInfo, appState, genericObject } from '../../interfaces/common';
import { fetchAllConfigurationRecords } from '../../redux/actions';
import { InteractiveText, StyledCard } from '../Utilities/custom.styled';
import SectionRenderTemplate from '../Utilities/SectionRenderTemplate';
import AddConfigure from './AddConfigure';

const ConfigureHome: React.FC = () => {
  const navigate = useNavigate();
  const translate = useLocalTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllConfigurationRecords());
  }, [dispatch]);

  const { configRecords } = useSelector((state: appState) => state);

  const itemRefs: any = useRef([]);
  const categoryImageContent: genericObject = {
    'language-service': Logos.GoogleTranslateLogo,
  };
  const convertDate = (lastupdated: string) => {
    return date.format(new Date(lastupdated), 'DD MMM YYYY HH:mm:ss');
  };
  const routeToPath = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate],
  );

  const handleRef = (element: Element, index: number) => {
    itemRefs.current[index] = element;
  };

  const createColumnData = () => {
    return configRecords
      ?.sort((a: ConfigurationInfo, b: ConfigurationInfo) => (new Date(b.lastUpdate) > new Date(a.lastUpdate) ? 1 : -1))
      .map((connectionItem, i) => {
        const key = `${i}`;
        return (
          <Flex key={key}>
            <StyledCard
              className="pointer"
              borderPositionCSS="border-bottom"
              key={key}
              onClick={() => routeToPath(`/${connectionItem.service}/${connectionItem.connectionId}`)}
              style={{ borderRadius: 0 }}
              ref={(element: Element) => handleRef(element, i)}
            >
              <CardContent style={{ paddingLeft: 0 }}>
                <SummaryItem
                  visual={
                    <Image
                      alt={connectionItem.service}
                      src={categoryImageContent[connectionItem.service]}
                      style={{ objectFit: 'fill' }}
                    />
                  }
                  primary={<InteractiveText>{connectionItem.accountName}</InteractiveText>}
                  secondary={
                    <Text variant="secondary">
                      {`${translate('last_updated')} ${convertDate(connectionItem.lastUpdate)}`}
                    </Text>
                  }
                />
              </CardContent>
            </StyledCard>
          </Flex>
        );
      });
  };

  const headerElement = () => {
    return (
      <Flex
        container={{
          direction: 'row',
          justify: 'between',
          alignItems: 'end',
        }}
      >
        <Text variant="h1" as="h1">
          {translate('global_config')}
        </Text>
        <Button onClick={() => routeToPath('/add-configuration')} variant="primary">
          {translate('add_new')}
        </Button>
      </Flex>
    );
  };

  const showConfigRecords = configRecords && Object.keys(configRecords).length > 0;

  return (
    <>
      <SectionRenderTemplate hideNavigation={true} header={showConfigRecords && headerElement()}>
        {showConfigRecords ? <Flex>{createColumnData()}</Flex> : <AddConfigure hideNavigation={true} />}
      </SectionRenderTemplate>
    </>
  );
};

export default ConfigureHome;
